import * as React from 'react'
import { classnames } from '@halo/_utils/classnames'
import { PageHeader } from '@pushly/aqe/lib/components'
import { noop } from '@pushly/aqe/lib/utils/noop'
import { FlagsList } from '@halo/portals/post-auth/flags/flags-list'

export const Flags = (props: any) => {
    return (
        <div className={classnames('flags-page')}>
            <PageHeader title="Flags" onTitleSet={noop} />

            <FlagsList />
        </div>
    )
}
